export const getGapSummaryReportNameCellValue = (
    trqkGapSummary: TrqkGapSummary,
): GapSummaryReportNameCellValue => {
    const { gap_analysis_id: gapAnalysisId, description } = trqkGapSummary;

    return { gapAnalysisId, description: description ?? null };
};
